/** Display-only provider evidence. Never infer VoP from settlement or AML status. */
function object(value: unknown): Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}
function text(value: unknown): string {
  return typeof value === 'string' ? value.trim().slice(0, 1000) : '';
}
function address(value: unknown): string {
  if (typeof value === 'string') return text(value);
  const fields = object(value);
  return [
    'address_line_1',
    'address_line_2',
    'line1',
    'line2',
    'street',
    'building_number',
    'postal_code',
    'postcode',
    'city',
    'country',
    'country_code',
  ]
    .map((key) => text(fields[key]))
    .filter(Boolean)
    .join(', ');
}
export function providerTransactionEvidence(payload: unknown): {
  senderAddress: string;
  payeeVerification: string;
} {
  const root = object(payload);
  const data = object(root['transaction'] ?? root['data'] ?? root);
  const payer = object(data['payer'] ?? data['debtor'] ?? data['sender']);
  const senderAddress = address(
    payer['address'] ??
      payer['postal_address'] ??
      data['payerAddress'] ??
      data['debtorAddress'] ??
      data['payer_address'],
  );
  const verification = data['verification_of_payee'] ?? data['verificationOfPayee'];
  const result = object(verification);
  // Keep the provider's explicit result verbatim; a boolean/unknown object is not a match.
  const payeeVerification =
    text(verification) ||
    text(result['result']) ||
    text(result['status']) ||
    text(result['match_status']);
  return { senderAddress, payeeVerification };
}
